const createBgSet = (png: string, webp: string): string => `
  image-set(
    url(${webp}) type("image/webp"),
    url(${png}) type("image/png")
)`;

export { createBgSet };
